export default __webpack_public_path__ + "static/media/monthly-cash.bcdb7f8d.svg";